if (!customElements.get('pack-builder')) {
  customElements.define(
    'pack-builder',
    class PackBuilder extends HTMLElement {
      connectedCallback() {
        this.addEventListener('click', this.onClick.bind(this));

        // El evento close del dialog no llega en todos los navegadores, asi
        // que el estado se sigue mirando el atributo open: cubre la X, el
        // clic fuera, Escape y el cierre por codigo.
        this.observador = new MutationObserver(() => this.sincronizarVentana());
        this.querySelectorAll('.pb-pack__panel').forEach((panel) => {
          this.observador.observe(panel, { attributes: true, attributeFilter: ['open'] });
        });

        // El contador no baja de 1 aunque se escriba a mano.
        this.addEventListener('change', (event) => {
          if (!event.target.classList.contains('pb-qty__input')) return;

          const pack = event.target.closest('.pb-pack');
          if (!pack) {
            event.target.value = Math.max(1, parseInt(event.target.value, 10) || 1);
            return;
          }

          const units = parseInt(pack.dataset.units, 10) || 0;
          const others = this.packTotal(pack) - (parseInt(event.target.value, 10) || 0);
          const wanted = Math.max(0, parseInt(event.target.value, 10) || 0);
          event.target.value = Math.min(wanted, units - others);
          this.refreshPack(pack);
        });
      }

      disconnectedCallback() {
        this.observador?.disconnect();
        document.body.classList.remove('pb-modal-abierto');
      }

      sincronizarVentana() {
        this.querySelectorAll('.pb-pack').forEach((pack) => {
          const abierto = !!pack.querySelector('.pb-pack__panel[open]');
          pack.classList.toggle('pb-pack--open', abierto);
          pack.querySelector('.pb-pack__toggle')?.setAttribute('aria-expanded', String(abierto));
        });

        const alguno = document.querySelector('.pb-pack__panel[open]');
        document.body.classList.toggle('pb-modal-abierto', !!alguno);
      }

      onClick(event) {
        const step = event.target.closest('.pb-qty__step');
        if (step) return this.stepQuantity(step);

        const single = event.target.closest('.pb-item__add');
        if (single) return this.addSingle(single);

        const toggle = event.target.closest('.pb-pack__toggle');
        if (toggle) return this.togglePack(toggle);

        const packAdd = event.target.closest('.pb-pack__add');
        if (packAdd) return this.addPack(packAdd);

        const cerrar = event.target.closest('.pb-pack__close');
        if (cerrar) return this.closePack(cerrar.closest('.pb-pack'));

        // Clic sobre el fondo de la ventana: el propio dialog es el destino.
        if (event.target.classList.contains('pb-pack__panel')) {
          return this.closePack(event.target.closest('.pb-pack'));
        }
      }

      stepQuantity(button) {
        const input = button.parentElement.querySelector('.pb-qty__input');
        const pack = button.closest('.pb-pack');
        const step = parseInt(button.dataset.step, 10);
        let next = (parseInt(input.value, 10) || 0) + step;

        if (pack) {
          // Dentro de un pack el total esta fijo: no se puede pasar del tamano.
          const units = parseInt(pack.dataset.units, 10) || 0;
          const others = this.packTotal(pack) - (parseInt(input.value, 10) || 0);
          next = Math.min(next, units - others);
          input.value = Math.max(0, next);
          this.refreshPack(pack);
          return;
        }

        input.value = Math.max(1, next);
      }

      packTotal(pack) {
        return Array.from(pack.querySelectorAll('.pb-flavor .pb-qty__input')).reduce(
          (total, input) => total + (parseInt(input.value, 10) || 0),
          0
        );
      }

      refreshPack(pack) {
        const units = parseInt(pack.dataset.units, 10) || 0;
        const total = this.packTotal(pack);
        const missing = units - total;
        const button = pack.querySelector('.pb-pack__add');

        const counter = pack.querySelector('[data-count]');
        if (counter) counter.textContent = total;

        pack.querySelectorAll('.pb-flavor [data-step="1"]').forEach((step) => {
          step.disabled = total >= units;
        });

        pack.classList.toggle('pb-pack--complete', missing === 0);
        button.setAttribute('aria-disabled', String(missing !== 0));
        button.textContent =
          missing > 0 ? button.dataset.remainingLabel.replace('[n]', missing) : button.dataset.addLabel;

        if (missing !== 0) return;
        pack.querySelector('.pb-pack__error')?.setAttribute('hidden', '');
      }

      addSingle(button) {
        const item = button.closest('.pb-item');
        const quantity = parseInt(item.querySelector('.pb-qty__input')?.value, 10) || 1;

        this.addToCart(button, [{ id: Number(button.dataset.variant), quantity }]);
      }

      // La ventana se abre por encima de la pagina para que se entienda que
      // hay que elegir; antes el reparto quedaba abajo y pasaba inadvertido.
      togglePack(button) {
        const pack = button.closest('.pb-pack');
        const panel = pack.querySelector('.pb-pack__panel');
        if (panel.open) return this.closePack(pack);

        this.querySelectorAll('.pb-pack').forEach((other) => {
          if (other !== pack) this.closePack(other);
        });

        if (typeof panel.showModal === 'function') {
          panel.showModal();
        } else {
          panel.setAttribute('open', '');
        }

        this.sincronizarVentana();
        this.refreshPack(pack);
      }

      closePack(pack) {
        if (!pack) return;

        const panel = pack.querySelector('.pb-pack__panel');
        if (panel?.open) {
          if (typeof panel.close === 'function') panel.close();
          else panel.removeAttribute('open');
        }

        this.sincronizarVentana();
      }

      addPack(button) {
        const pack = button.closest('.pb-pack');
        const units = parseInt(pack.dataset.units, 10) || 0;
        const error = pack.querySelector('.pb-pack__error');

        if (this.packTotal(pack) !== units) {
          error?.removeAttribute('hidden');
          return;
        }

        error?.setAttribute('hidden', '');

        // Cada sabor entra como su propio producto: el carrito muestra las
        // unidades y el precio de pack lo pone el cupon del tramo.
        const items = [];
        const properties = {};
        let sueltos = true;

        pack.querySelectorAll('.pb-flavor').forEach((flavor) => {
          const quantity = parseInt(flavor.querySelector('.pb-qty__input').value, 10) || 0;
          if (quantity === 0) return;

          properties[flavor.dataset.flavor] = quantity;
          if (flavor.dataset.variant) {
            items.push({ id: Number(flavor.dataset.variant), quantity });
          } else {
            sueltos = false;
          }
        });

        // Solo las colecciones marcadas entran sueltas; el resto viaja como
        // producto pack, que lleva su precio adentro y no pelea con ninguna
        // regla de descuento.
        if (!pack.hasAttribute('data-loose') || !sueltos || !window.packTiers) {
          this.addToCart(button, [{ id: Number(button.dataset.variant), quantity: 1, properties }], pack);
          return;
        }

        this.addToCart(button, items, pack);
      }

      // Tras agregar, el pack vuelve a cero: si no, las cantidades viejas dejan
      // los botones + bloqueados y no se puede armar otro.
      resetPack(pack) {
        pack.querySelectorAll('.pb-flavor .pb-qty__input').forEach((input) => {
          input.value = 0;
        });
        this.refreshPack(pack);
        this.closePack(pack);
      }

      async addToCart(button, items, pack) {
        const drawer = document.querySelector('cart-drawer');
        button.classList.add('loading');
        button.setAttribute('aria-disabled', 'true');

        try {
          if (window.packTiers) {
            await window.packTiers.agregar(items);
            if (pack) this.resetPack(pack);
            return;
          }

          const response = await fetch(`${window.routes.cart_add_url}.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
            body: JSON.stringify({
              items,
              sections: drawer ? drawer.getSectionsToRender().map((section) => section.id) : [],
              sections_url: window.location.pathname,
            }),
          });

          const result = await response.json();
          if (result.status) throw new Error(result.description || result.message);

          if (pack) this.resetPack(pack);

          if (drawer) {
            drawer.renderContents(result);
          } else {
            window.location.href = window.routes.cart_url;
          }
        } catch (e) {
          // Sin carrito lateral o con error, la pagina del carrito siempre sirve.
          window.location.href = window.routes.cart_url;
        } finally {
          button.classList.remove('loading');
          button.removeAttribute('aria-disabled');
        }
      }
    }
  );
}

// reset del pack 2026-08-22

// dos columnas en celular 2026-08-22
